import { useTranslation } from 'react-i18next';

import { CircuitsSearchForm } from '@frontend/features/travel-services/components/CircuitsSearchForm';
import { TravelServicesPage } from '@frontend/features/travel-services/components/TravelServicesPage';
import { useSearchFormKey } from '@frontend/features/travel-services/useSearchUrlState';

/** Buscador de circuitos (vertical circuits de Rutero). */
export const Circuits = () => {
  const { t } = useTranslation();
  // Aplicar una búsqueda reciente remonta el buscador: si no, los campos
  // (que se llenan al montar) quedarían vacíos bajo los resultados nuevos.
  const formKey = useSearchFormKey();

  return (
    <TravelServicesPage
      title={t('common.nav.circuits')}
      intro={t('travelServices.circuitsIntro')}
    >
      <CircuitsSearchForm key={formKey} />
    </TravelServicesPage>
  );
};

export default Circuits;
